import { TGetOffersResponse } from 'lendingApi/lapiOverrides.types';
import { getDurationInMonths } from 'utils/durationHelper';

export const renderDurationMessaging = (
  duration: TGetOffersResponse['data']['offers'][number]['duration'],
) => {
  const durationInMonths = getDurationInMonths(duration);

  if (durationInMonths === 12) {
    return 'Up to 12 months';
  }
  return `Up to ${durationInMonths} months`;
};
